/* eslint-disable import/no-cycle */
// TODO remove import cycles
import Filter from '../filter/filter';
import Modal from '../modal/modal';
/* eslint-enable import/no-cycle */

export default new class Search {
  constructor() {
    
    this.modalSearchInput = '.js-modalSearchInput';
    this.searchInput = '.js-searchInput';
    this.modalLink = 'search-result';
    this.minLengthForRequest = 2;
    this.delayForRequest = 500;
    this.timer = null;
    this.page = 1;

    this.mobileHeaderSearchIcon = '.header__search:not(._services)';
    this.bindEvents();
  }

  bindEvents() {
    if (!$('.search').length) return;

    $(document)
    // show search modal on mobile
      .on('click', this.mobileHeaderSearchIcon, () => {
        const $searchResultModal = $(`.${Modal.modalContent}[data-modal='${this.modalLink}']`);

        // Modal.openModal(null, $searchResultModal);
      })
      .on('input', this.searchInput, (e) => {
        const requestText = $(e.currentTarget).val().trim();

        if (requestText.length > this.minLengthForRequest) {
          if (this.timer) {
            clearTimeout(this.timer);
          }

          this.timer = setTimeout(() => {
            // show modal-search
            const $searchResultModal = $(`.${Modal.modalContent}[data-modal='${this.modalLink}']`);
            const $modalSearchInput = $searchResultModal.find(this.modalSearchInput);

            if ($modalSearchInput.length == 0) {
              return
            }
            // put request text to the input in search modal
            $modalSearchInput.val(requestText);
            // Modal.openModal(null, $searchResultModal);

            // set default for filter
            Filter.isJournalSelected = false;
            Filter.isYearSelected = false;
            Filter.dateStart = '';
            Filter.dateEnd = '';

            // set carret in the end of input content
            $modalSearchInput[0].selectionStart = $modalSearchInput.val().length;
            $modalSearchInput[0].selectionEnd = $modalSearchInput.val().length;
            $modalSearchInput.focus();

            // send search request
            Filter.getFilterParams(this.page);
          }, this.delayForRequest);
        }
      });
  }
}();
